<template>
  <section v-if="available" class="q-pa-sm">
    <h6 class="q-my-sm">{{ $t('Location labels') }}</h6>
    <div v-if="!available">{{ $t('Location labels are unavailable') }}</div>
    <template v-else>
      <location-alias-tools v-if="warehouseId" :warehouse-id="warehouseId" @imported="load" />
      <q-form @submit="add">
        <q-input v-model="label" :label="$t('Existing warehouse label')" :disable="busy" />
        <q-btn type="submit" :label="$t('Link label')" :disable="busy || !label" />
      </q-form>
      <div v-if="error" role="alert" class="text-negative">{{ error }}</div>
      <ul>
        <li v-for="alias in aliases" :key="alias.id">
          {{ alias.value }} — {{ alias.state }}
          <q-btn v-if="alias.state === 'active' && alias.kind === 'alias'" flat
            :label="$t('Retire label')" :disable="busy" @click="retire(alias)" />
        </li>
      </ul>
      <q-expansion-item :label="$t('Location label history')">
        <q-btn :label="$t('Load history')" :disable="busy" @click="loadHistory(false)" />
        <ul><li v-for="entry in history" :key="entry.id">
          {{ entry.created_at }} — {{ entry.action }} — {{ entry.raw }} — {{ entry.actor }}
        </li></ul>
        <q-btn v-if="historyNext" :label="$t('Load more')" :disable="busy" @click="loadHistory(true)" />
      </q-expansion-item>
    </template>
  </section>
</template>
<script>
import LocationAliasTools from './LocationAliasTools.vue';
export default {
  components: { LocationAliasTools },
  props: { placeId: { type: [String, Number], required: true }, warehouseId: { type: [String, Number], default: null } },
  data() { return { label: '', history: [], historyNext: null, aliases: [], available: false, busy: false, error: '', generation: 0 }; },
  watch: { placeId() { this.load(); }, warehouseId() { this.load(); } },
  mounted() { this.load(); },
  beforeUnmount() { this.generation += 1; },
  methods: {
    request(data) {
      return this.$service.storagePlace.identifierRequest({ ...data, place: this.placeId, warehouse: this.warehouseId });
    },
    async load() {
      this.generation += 1;
      const { generation } = this;
      this.aliases = []; this.history = []; this.historyNext = null; this.error = '';
      try {
        const service = this.$service.storagePlace;
        const capability = service.identifierCapabilities ? await service.identifierCapabilities() : {};
        if (generation !== this.generation) return;
        this.available = capability.locationAliases === true;
        if (!this.available) return;
        const result = await this.request({ action: 'list' });
        if (generation === this.generation) this.aliases = result.aliases || [];
      } catch (error) { if (generation === this.generation) this.error = error.message; }
    },
    async loadHistory(more) {
      if (this.busy) return;
      this.busy = true; const generation = this.generation;
      try {
        const result = await this.request({ action: 'audit', after: more ? this.historyNext : 0 });
        if (generation === this.generation) { this.history = more ? [...this.history, ...result.items] : result.items; this.historyNext = result.next; }
      } catch (error) { if (generation === this.generation) this.error = error.message; }
      finally { this.busy = false; }
    },
    async add() {
      if (this.busy) return;
      this.busy = true; this.error = '';
      try { await this.request({ action: 'add', raw: this.label }); this.label = ''; await this.load(); }
      catch (error) { this.error = error.message || 'Label was not linked'; }
      finally { this.busy = false; }
    },
    async retire(alias) {
      if (this.busy) return;
      this.busy = true; this.error = '';
      try { await this.request({ action: 'retire', identifier: alias.id, version: alias.version }); await this.load(); }
      catch (error) { this.error = error.message || 'Label was not retired'; }
      finally { this.busy = false; }
    },
  },
};
</script>
